module.exports = __webpack_public_path__ + "static/media/prioritize.ff96bfe2.png";